import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
const apolloCacheConfig = new InMemoryCache({
    typePolicies: {
        TalentNboxModuleProcessesResult: {
            keyFields: false
        },
        OrganizationNode: {
            merge: true,
            fields: {
                users: relayStylePagination(),
                notStudyingUsers: relayStylePagination(),
                teamsConnection: relayStylePagination()
            }
        },
        UserOrganizationNode: {
            merge: true,
            fields: {
                users: relayStylePagination()
            }
        },
        GoalNodeConnection: {
            merge: true,
            fields: {
                goals: relayStylePagination([
                    'query'
                ])
            }
        },
        TalentQuery: {
            merge: true
        },
        TalentPerformanceQueries: {
            merge: true
        },
        TalentPerformanceAdministratorQueries: {
            merge: true
        },
        TalentPerformanceAdministrator: {
            merge: true
        },
        TalentPerformanceCompetencesAdministrator: {
            merge: true
        },
        TalentFeedbackQueries: {
            merge: true
        },
        TalentCompetencesQueries: {
            merge: true
        },
        TalentDashboardQuery: {
            merge: true
        },
        TalentRecognitionQueries: {
            merge: true
        },
        TalentRecognitionAdministratorQueries: {
            merge: true
        },
        DashboardLeaderQuery: {
            merge: true
        },
        HRISQueries: {
            merge: true
        },
        OrganizationChartUserReports: {
            merge: true
        },
        TalentDIPQuery: {
            merge: true
        },
        LeaderQuery: {
            merge: true
        },
        CollaboratorQuery: {
            merge: true
        },
        TimeoffQueries: {
            merge: true
        },
        TalentReportsQuery: {
            merge: true
        },
        NboxQueries: {
            merge: true
        },
        WorkFlowQueries: {
            merge: true
        },
        ATSRecruitmentQuery: {
            merge: true
        },
        SecurityQuery: {
            merge: true
        },
        TalentUserSession: {
            merge: true
        },
        UserSession: {
            merge: true
        },
        TalentSession: {
            merge: true
        },
        LearningSession: {
            merge: true
        },
        CentralizedSession: {
            merge: true
        },
        FoundationLeaderQuery: {
            merge: true
        },
        FoundationHomeUserQuery: {
            merge: true
        },
        UserProfileQueries: {
            merge: true
        },
        InternalCommsQueries: {
            merge: true
        },
        InternalCommsChannelsQueries: {
            merge: true
        },
        InternalCommsCommentsQueries: {
            merge: true
        },
        InternalCommsPostsQueries: {
            merge: true
        },
        AuditLogResolvers: {
            merge: true
        },
        CorporateDocumentsQueries: {
            merge: true
        },
        FeaturesFlagQuery: {
            merge: true
        },
        KnowledgeHubQuery: {
            merge: true
        },
        KnowledgeHubConfigQuery: {
            merge: true
        },
        KnowledgeHubV2AdminQuery: {
            merge: true
        },
        KnowledgeHubV2CollaboratorQuery: {
            merge: true
        },
        KnowledgeHubAdminTagMutation: {
            merge: true
        },
        ContentEnrollmentMutations: {
            merge: true
        },
        EnrollmentQuery: {
            merge: true
        },
        CourseQuery: {
            merge: true
        },
        QuizMainQueries: {
            merge: true
        },
        BenefitQueryBuilder: {
            merge: true
        },
        SegmentationQueries: {
            merge: true
        },
        ScormQuery: {
            merge: true
        },
        TimeQueries: {
            merge: true
        },
        TimeShiftAssignmentsQueries: {
            merge: true
        },
        TimeShiftsQueries: {
            merge: true
        },
        TimeAttendanceLocationsQueries: {
            merge: true
        },
        TimeCollaboratorMarkingConfigsQueries: {
            merge: true
        },
        TimeAttendanceMarksQueries: {
            merge: true
        },
        AgentOSQuery: {
            merge: true
        },
        AnalyticsOrganizationQuery: {
            merge: true
        },
        TimeDailyAttendanceQueries: {
            merge: true
        },
        TimeAttendanceCardsQueries: {
            merge: true
        },
        TimeOrganizationAttendancePreferencesQueries: {
            merge: true
        },
        TimeOrganizationAttendancePreferencesMutations: {
            merge: true
        },
        PayrollQuery: {
            merge: true
        },
        Query: {
            fields: {
                courses: relayStylePagination([
                    'query'
                ]),
                news: relayStylePagination([
                    'query'
                ]),
                skillB2BResultTeamNew: relayStylePagination([
                    'query'
                ]),
                featuredArticles: relayStylePagination(),
                coursesB2BAdmin: relayStylePagination([
                    'query'
                ]),
                academies: relayStylePagination([
                    'query'
                ]),
                packAcademies: relayStylePagination([
                    'query'
                ]),
                articlesV2: relayStylePagination([
                    'search',
                    'categories',
                    'orderBy'
                ]),
                talent_feedback: {
                    merge: false
                },
                userTeams: relayStylePagination([
                    'query'
                ])
            }
        }
    }
});
export { apolloCacheConfig };
